import React from 'react';
import useTheme from 'branding/theme';
import getIconColor from '../../getIconColor';
const CaretIcon = ({ direction = 'forward', type = 'utility', size = 'regular', disabled = false, styles, ...rest }) => {
    const { colors, sizing } = useTheme();
    const color = getIconColor(colors, type, disabled);
    const sizePx = sizing.widths.icon[size];
    const rotateDeg = { forward: 0, down: 90, backward: 180, up: 270 }[direction];
    const mergedStyles = {
        minWidth: sizePx,
        ...styles
    };
    return (React.createElement("svg", { viewBox: "0 0 20 20", width: sizePx, style: mergedStyles, ...rest, role: "img", "aria-label": direction },
        React.createElement("path", { d: "M7.5 18.3l5.6-5.7m2.5-3.1L7.5 1.3", stroke: color, strokeWidth: "2", strokeLinecap: "round", transform: `rotate(${rotateDeg},10,10)` })));
};
export default CaretIcon;
//# sourceMappingURL=index.js.map